import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentosAdjuntosService {
  public sessionInfo = JSON.parse(StorageService.getSession());
  public ciaId = this.sessionInfo.id_cia;
  constructor(
    private apiService: ApiService,
    private http: HttpClient
  ) {

  }

  public archivosAdjuntos(numint: number) {
    this.apiService.setUrlPathApi("archivos/adjuntos");
    return this.apiService.execGetQueryJson(`?numint=${numint}`).pipe();
  }

  //Para visualizar el pdf
  public compr010ObtenerPdf(item: number,id_cia: any) {
    this.apiService.setUrlPathApi(`archivos/compr010/pdf/${item}`);
    return this.apiService.execGetQueryJson(`?id_cia=${id_cia}`).pipe();
  }

  //******************OBTENER********************
  public compr010BuscarAdjuntos(tipo: any,docume: any) {
    this.apiService.setUrlPathApi(`archivos/compr010-adjuntos`);
    return this.apiService.execGetQueryJson(`?tipo=${tipo}&docume=${docume}`).pipe();
  }
  public cabBuscarAdjuntos(tipdoc:any,numint: number) {
    this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/cab-adjuntos`);
    return this.apiService.execGetQueryJson(`?tipdoc=${tipdoc}&numint=${numint}`).pipe();
  }

  //******************DESCARGAR********************
  compr010downloadArchivosAdjuntos(id: number,id_cia: number,docume: any): Observable<any> {
    this.apiService.setUrlPathApi('archivos/compr010-adjunto/public/descargar/'+ id);
    return this.apiService.execGetQueryJsonPDF(`?id_cia=${id_cia}&docume=${docume}`).pipe();
  }
  cabdownloadArchivosAdjuntos(id: number,tipdoc:any, numint: any): Observable<any> {
    this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/cab-adjunto/public/descargar/`+ id);
    return this.apiService.execGetQueryJsonPDF(`?tipdoc=${tipdoc}&numint=${numint}`).pipe();
  }

  //***************GUARDAR**********************
  compr010Imagen(data: any): Observable<any> {
    this.apiService.setUrlPathApi(`archivos/compr010-adjunto`);
    return this.apiService.executePostJson(data).pipe();
  }
  docCabImagen(data: any): Observable<any> {
    this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/cab-adjunto`);
    return this.apiService.executePostJson(data).pipe();
  }

  //***************ELIMINAR**********************
  eliminarcompr010(id: any,tipo: any,docume: any): Observable<any> {
    this.apiService.setUrlPathApi('archivos/compr010-adjunto/'+ id);
    return this.apiService.executeDeleteJson(`?tipo=${tipo}&docume=${docume}`);
  }
  eliminardocCab(id: any, tipdoc:any,numint: any): Observable<any> {
    this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/cab-adjunto/`+ id);
    return this.apiService.executeDeleteJson(`?tipdoc=${tipdoc}&numint=${numint}`);
  }

  //***************ACTUALIZAR**********************
  compr010AdjuntoUpdate(data: any): Observable<any> {
    this.apiService.setUrlPathApi(`archivos/compr010-adjunto`);
    return this.apiService.executePutJson(data).pipe();
  }
  cabAdjuntoActualizar(data: any): Observable<any> {
    this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/cab-adjunto`);
    return this.apiService.executePutJson(data).pipe();
  }


}
